"use client";

import { getLocaleId } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getLocaleId";
import { getTypographyVariant } from "@faire/sdui/lib/deprecated/getTypographyVariant";
import { getColor } from "@faire/sdui/lib/getColor";
import { IButtonElement } from "@faire/web-api--source/indigofair/data/IButtonElement";
import { IFaireIcon } from "@faire/web-api--source/indigofair/data/IFaireIcon";
import { IImageOrIcon } from "@faire/web-api--source/indigofair/data/IImageOrIcon";
import { ITextElement } from "@faire/web-api--source/indigofair/data/ITextElement";
import { TextDecorator } from "@faire/web-api--source/indigofair/data/TextDecorator";
import { Button } from "@faire/web/slate-deprecated/Button";
import { Typography } from "@faire/web/slate/Typography";

import { extractLinkFromActions } from "../../../__internal__/ActionHandler/extractLinkFromActions";
import { useSDUIOnClickHandler } from "../../../__internal__/ActionHandler/useSDUIOnClickHandler";
import { LoggingEventParams } from "../../../__internal__/types";
import { SDUIImageOrIconRenderer } from "../../ImageOrIcon/SDUIImageOrIconRenderer";
import { getCssTextAlign } from "../../Typography/styles/textJustificationStyleUtils";

interface IProps {
  title: ITextElement;
  button: IButtonElement;
  loggingData: LoggingEventParams;
}

const SDUICarouselHeaderTitleMobile: React.FC<IProps> = ({
  title,
  button,
  loggingData,
}) => {
  const { link, nonNavigationActions } = extractLinkFromActions(
    button?.on_click ?? []
  );
  const typographyVariant = getTypographyVariant(title.style?.type, [
    title.style?.decorator === ITextElement.TextDecorator.TEXT_DECORATOR_UNKNOWN
      ? TextDecorator.TEXT_DECORATOR_UNKNOWN
      : (title.style?.decorator as TextDecorator),
  ]);
  const onClickHandler = useSDUIOnClickHandler(
    nonNavigationActions,
    loggingData,
    { logSDUIClickEvent: true, logLegacyClickEvent: true }
  );
  const decoratorStyle =
    title.style?.decorator !== ITextElement.TextDecorator.UNDERLINE
      ? "!no-underline"
      : "";
  const colorToken = getColor(title.style?.color);
  return (
    <Button
      variant="tertiary"
      onClick={onClickHandler}
      linkTo={link}
      tertiaryColor={colorToken}
      style={{
        fontFamily: "inherit",
        fontSize: "inherit",
        fontWeight: "inherit",
        lineHeight: "inherit",
        letterSpacing: "inherit",
      }}
      className={decoratorStyle}
    >
      <Typography
        variant={typographyVariant}
        color={colorToken}
        maxLines={title.style?.max_lines}
        align={getCssTextAlign(title.style?.text_justification)}
        lang={getLocaleId() ?? "en"}
        data-test-id="sdui-typography-text"
      >
        {title.text}
        <SDUIImageOrIconRenderer
          imageOrIcon={IImageOrIcon.build({
            icon: IFaireIcon.build({
              type: IFaireIcon.Type.CHEVRON,
              size: 12,
            }),
          })}
          parentColorToken={title.style?.color}
          parentFontStyle={title.style?.type}
          componentStyle={{
            strokeWidth: "1.5px",
            verticalAlign: "middle",
            display: "inline",
            marginLeft: "8px",
          }}
        />
      </Typography>
    </Button>
  );
};

export default SDUICarouselHeaderTitleMobile;
